import clsx from 'clsx';
import React from 'react';

import Button from '@/src/components/common/Elements/Button/Button';
import Icon, { ICONS } from '@/src/components/common/Elements/Icon/Icon';

export const EllipsisThreadButton = (props) => {
  const { onClick, className } = props;

  return (
    <div className={clsx('container--ellipsisThreadButton')}>
      <Button
        className={clsx(
          'tw-max-w-[50px] tw-w-full',
          'tw-mt-[10px]',
          'tw-rounded-[34px]',
          className
        )}
        buttonClassSettings={{ variant: 'inverse', size: 'sm', position: 'center' }}
        onClick={onClick}
      >
        <Icon icon={ICONS.ellipsis_horizontal} />
      </Button>

      {props.children}
    </div>
  );
};
